import React, { Component, Fragment } from 'react';
import { Button, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import moment from 'moment';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

// import Flatpickr from "react-flatpickr";
import '../../../node_modules/flatpickr/dist/themes/airbnb.css';

import {
  patchOverviewEdits,
  updateOverviewEdits,
} from '../../redux/actions/overviewEditorActions';
import { isBrowser } from '../../lib/utils';
import { getToastMsg } from '../../components/ErrorMessage';

let Flatpickr = '';

if (isBrowser()) Flatpickr = require('react-flatpickr').default;

class DateModal extends Component {
  state = {
    date: moment(this.props.trekStartDate).format('YYYY-MM-DD'),
    requestIsPending: false,
    netWorkError: '',
    canShowFlatPickr: false,
  };

  render() {
    const {
      toggle,
      // handleContinue,
      // trekStartDate,
    } = this.props;
    const { requestIsPending, netWorkError, date } = this.state;

    return (
      <Fragment>
        <ModalHeader toggle={requestIsPending ? () => {} : toggle}>
          CONFIRM YOUR TREK START DATE
        </ModalHeader>
        <ModalBody>
          {isBrowser() && (
            <Flatpickr
              id="flatpickr"
              options={{
                inline: true,
                minDate: 'today',
                disableMobile: 'true',
                defaultDate: [date],
              }}
              onChange={this.handleDateChange}
            />
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={this.handleOnClick}
            className={requestIsPending ? 'btn-loading' : ''}
          >
            <i className="icon icon-hg-dollor" />{' '}
            {netWorkError ? 'Try Again' : requestIsPending ? 'Setting Date' : 'Continue'}
            {netWorkError}
          </Button>
        </ModalFooter>
      </Fragment>
    );
  }

  handleOnClick = () => {
    const { handleContinue, patchOverviewEdits, trekId, updateOverviewEdits } = this.props;
    this.setState({ requestIsPending: true, netWorkError: '' });
    const selectedDate = moment(this.state.date).format('YYYY-MM-DD');
    patchOverviewEdits(trekId, { start_date: selectedDate })
      .then(response => {
        if (response.start_date === selectedDate) {
          updateOverviewEdits({ start_date: selectedDate });
          this.setState({ requestIsPending: false });
          handleContinue();
          getToastMsg({ status: 'success', type: 'dateChangeOnTrekBuy' });
        }
      })
      .catch(err => {
        this.setState({
          requestIsPending: false,
          netWorkError: 'Network Error. Try again!',
        });
        getToastMsg({ status: 'error', type: 'dateChangeOnTrekBuy' });
      });
  };

  handleDateChange = date => {
    date = date[0];
    this.setState({ date });
  };
}

const mapStateToProps = ({ selectedTrek, user }) => {
  let trekStartDate = selectedTrek.trek.start_date;
  // TODO: or if invalid date as in Logically
  if (!(moment(trekStartDate)._isValid && moment(trekStartDate).isAfter(moment())))
    trekStartDate = null;
  return {
    trekId: selectedTrek.trek.id,
    trekName: selectedTrek.trek.name,
    trekStartDate,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    patchOverviewEdits: (trekId, data) => dispatch(patchOverviewEdits(trekId, data)),
    updateOverviewEdits: patchObj => dispatch(updateOverviewEdits(patchObj)),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(DateModal)
);



// WEBPACK FOOTER //
// ./src/screens/Trek/DateModal.js